module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/email-edb81e257f766dcf134c4a0b65f446c4.png";